import { OnInit } from '@angular/core';
import { ConfirmDialogComponent } from '@shared/confirm-dialog/confirm-dialog.component';
import { MatBottomSheet } from '@angular/material';
import { OccurencesService } from '@app/occurences/occurences.service';
import { SnackbarService } from '@app/shared/services/snackbar.service';
import { AuthService } from '@app/core/auth/auth.service';
var OccurrenceReadManagerComponent = /** @class */ (function () {
    function OccurrenceReadManagerComponent(occurenceService, _snackbarService, bottomSheet, authService) {
        this.occurenceService = occurenceService;
        this._snackbarService = _snackbarService;
        this.bottomSheet = bottomSheet;
        this.authService = authService;
        this.currentGestor = this.occurenceService.getCurrentGestorLogged();
    }
    OccurrenceReadManagerComponent.prototype.ngOnInit = function () {
    };
    OccurrenceReadManagerComponent.prototype.readComment = function (comment) {
        var _this = this;
        this.bottomSheet.open(ConfirmDialogComponent, {
            data: {
                message: 'Essa ação desabilita a notificação na grid de demandas. Essa ação não pode ser desfeita. Deseja continuar?',
                confirmMessage: 'Sim',
                cancelMessage: 'Não'
            }
        }).afterDismissed().subscribe(function (data) {
            if (data && data.message === 'Confirm') {
                var commentDto = {
                    id: comment.id,
                    // readUserName: this.authService.currentUserValue.name,
                    // userName: comment.userName,
                    occurrenceId: comment.occurrenceId,
                    readDateTime: new Date()
                };
                _this.occurenceService.manageReadComment(commentDto).subscribe(function (resp) {
                    _this.afterReadSuccess(comment, resp.readUserName, resp.readDateTime);
                }, function (err) {
                    _this.afterReadFail();
                });
            }
        });
    };
    OccurrenceReadManagerComponent.prototype.afterReadSuccess = function (comment, readUserName, readDateTime) {
        comment.readUserName = readUserName;
        comment.readDateTime = readDateTime;
        this._snackbarService.showSnackbar('O comentário foi lido com sucesso.', 'OK');
    };
    OccurrenceReadManagerComponent.prototype.afterReadFail = function () {
        this._snackbarService.showSnackbar("Falha ao atualizar o comentário.", "OK");
    };
    OccurrenceReadManagerComponent.prototype.handlePermissionComment = function () {
        return true;
    };
    return OccurrenceReadManagerComponent;
}());
export { OccurrenceReadManagerComponent };
